<template>
    <v-form @submit.prevent="saveDocument" ref="form">
        <v-card class="elevation-1 rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">{{ mode }} eDocument</span>
                <v-spacer></v-spacer>
                 <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
           
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. {{errorMessage}}
            </v-alert>  
            <v-card-text>

                <!-- documentTitle-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-text-field label="Title"
                            v-model="documentTitle"
                            :rules="[rules.required]"
                            maxlength="100"
                            hint="Max 100 alphanumeric characters"
                            :disabled="disabled"></v-text-field>
                    </v-flex>
                </v-layout>
                
                <!-- category-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-autocomplete
                            v-model="documentCategoryId"
                            :disabled="disabled"
                            :items="categories"
                            :loading="loading_categories"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Category"
                            item-text="categoryName"
                            item-value="documentCategoryId"
                            persistent-hint
                            :hint="categoryDescription"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    {{ data.item.categoryName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.categoryName"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>    
                    </v-flex>
                </v-layout>
                
                <!-- type -->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content mt-10">
                        <v-autocomplete
                            v-model="documentTypeId"
                            :disabled="disabled"
                            :items="types_filtered"
                            :loading="loading_categories"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Type"
                            item-text="typeName"
                            item-value="documentTypeId"
                            persistent-hint
                            :hint="typeDescription"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi ml-0">
                                    {{ data.item.typeName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.typeName"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>  
                    </v-flex>
                </v-layout>
                
                <!-- description -->
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-content mt-10"> 
                        <v-textarea 
                            v-model="documentDescription" 
                            :rules="[rules.required]"
                            label="Description" 
                            rows="2" 
                            color="primary">
                        </v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary" :disabled="disabled||loading||!completeFormData" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-form>
</template>
<script>
    
import edocumentsApi from '@/api/edocuments'

export default {
    name: 'AddEditDocumentHeader',
    components: {},
    data () {
        return {
            error: false,
            errorMessage: '',
            disabled: false,
            loading: false,
            loading_categories: false,

            //put this in rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
            },

            mode: '',
            categories: [],
            types: [],

            documentId: null,
            documentTitle: null,
            documentDescription: null,
            documentCategoryId: null,
            documentTypeId: null,
        }
    },
    methods: {
        async saveDocument() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate() && this.completeFormData) {
                    const data = {
                        documentId: this.documentId,
                        documentTitle: this.documentTitle,
                        documentDescription: this.documentDescription,
                        documentCategoryId: this.documentCategoryId,
                        documentTypeId: this.documentTypeId,
                    }
                    let response
                    if (this.isAddNewMode)
                        response = await edocumentsApi.addHeader(data)
                    else
                        response = await edocumentsApi.updateHeader(data)

                    if (response && response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getCategories() {
            try {
                this.loading_categories = true
                const response = await edocumentsApi.getCategories()
                if (response && response.status == 200) {
                    this.categories = response.data.categories
                    this.types = response.data.types
                }
                this.loading_categories = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setAdd() {
            this.clearForm()
            this.mode = 'Add'
            if (!this.categories.length) {
                this.getCategories()
            }
        },
        async setEdit(data) {
            this.mode = 'Update'
            
            if (!this.categories.length) {
                await this.getCategories()
            }

            //set existing data
            this.documentId = data.documentId
            this.documentTitle = data.documentTitle
            this.documentDescription = data.documentDescription
            this.documentCategoryId = data.documentCategoryId
            this.documentTypeId = data.documentTypeId
        },
        closeDialog() {
            this.$emit('update:dialogAddEditDocHeader', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.error = false
            this.errorMessage = ''
            this.loading = false
        },
    },
    computed: {
        categoryDescription() {
            if (this.documentCategoryId && this.categories.length) {
                return this.categories.find(x => x.documentCategoryId == this.documentCategoryId).categoryDescription
            }
            return ''
        },
        types_filtered() {
            if (this.documentCategoryId && this.types.length) {
                return this.types.filter(x => x.documentCategoryId == this.documentCategoryId)
            }
        },
        typeDescription() {
            if (this.documentTypeId && this.types_filtered && this.types_filtered.length) {
                const type = this.types_filtered.find(
                    x => x.documentTypeId == this.documentTypeId
                )
                return type ? type.typeDescription : ''
            }
            return ''
        },
        isAddNewMode() {
            return this.mode == 'Add'
        },
        completeFormData() {
            return this.documentTitle && 
                this.documentDescription &&
                this.documentCategoryId && 
                this.documentTypeId
        },
    }
}
</script>
<style scoped>
.form-content {
    padding:0px 20px 0px 20px;
    margin-top:-5x;
}
</style>